import {metadaApi} from '@dms/api/base';

import {
  GetMazdaWarrantyAssemblyGroupsApiResponse,
  GetMazdaWarrantyAssemblyGroupsApiResponseSchema,
  GetMazdaWarrantyCausalPartsApiResponse,
  GetMazdaWarrantyCausalPartsApiResponseSchema,
  GetMazdaWarrantyDamagesApiArg,
  GetMazdaWarrantyDamagesApiArgSchema,
  GetMazdaWarrantyDamagesApiResponse,
  GetMazdaWarrantyDamagesApiResponseSchema,
  GetMazdaWarrantyLocationsApiArg,
  GetMazdaWarrantyLocationsApiArgSchema,
  GetMazdaWarrantyLocationsApiResponse,
  GetMazdaWarrantyLocationsApiResponseSchema,
  GetMazdaWarrantySubAssemblyGroupsApiArg,
  GetMazdaWarrantySubAssemblyGroupsApiArgSchema,
  GetMazdaWarrantySubAssemblyGroupsApiResponse,
  GetMazdaWarrantySubAssemblyGroupsApiResponseSchema,
  GetMazdaWarrantySubletsApiResponse,
  GetMazdaWarrantySubletsApiResponseSchema,
  GetMazdaWarrantySymptomsApiArg,
  GetMazdaWarrantySymptomsApiArgSchema,
  GetMazdaWarrantySymptomsApiResponse,
  GetMazdaWarrantySymptomsApiResponseSchema,
  PostMazdaPortalLoginApiArg,
  PostMazdaPortalLoginApiArgSchema,
  PostMazdaPortalLoginApiResponse,
  PostMazdaPortalLoginApiResponseSchema,
} from './types';

const metadaMazdaIntegrationApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    postMazdaPortalLogin: build.query<PostMazdaPortalLoginApiResponse, PostMazdaPortalLoginApiArg>({
      query: (queryArg) => ({
        url: `/mazda_omn/v1/login`,
        method: 'POST',
        body: queryArg,
        queryArg,
      }),
      keepUnusedDataFor: 0,
      extraOptions: {
        responseSchema: PostMazdaPortalLoginApiResponseSchema,
        requestSchema: PostMazdaPortalLoginApiArgSchema,
      },
    }),
    getMazdaWarrantyAssemblyGroups: build.query<GetMazdaWarrantyAssemblyGroupsApiResponse, void>({
      query: () => ({
        url: `/mazda_omn/v1/warranty/assembly-groups`,
      }),
      extraOptions: {
        responseSchema: GetMazdaWarrantyAssemblyGroupsApiResponseSchema,
      },
    }),
    getMazdaWarrantySubAssemblyGroups: build.query<
      GetMazdaWarrantySubAssemblyGroupsApiResponse,
      GetMazdaWarrantySubAssemblyGroupsApiArg
    >({
      query: (queryArg) => ({
        url: `/mazda_omn/v1/warranty/sub-assembly-groups`,
        params: {assemblyGroupCode: queryArg.assemblyGroupCode},
        queryArg,
      }),
      extraOptions: {
        responseSchema: GetMazdaWarrantySubAssemblyGroupsApiResponseSchema,
        requestSchema: GetMazdaWarrantySubAssemblyGroupsApiArgSchema,
      },
    }),
    getMazdaWarrantySymptoms: build.query<
      GetMazdaWarrantySymptomsApiResponse,
      GetMazdaWarrantySymptomsApiArg
    >({
      query: (queryArg) => ({
        url: `/mazda_omn/v1/warranty/warranty-symptoms`,
        params: {assemblyGroupCode: queryArg.assemblyGroupCode},
        queryArg,
      }),
      extraOptions: {
        responseSchema: GetMazdaWarrantySymptomsApiResponseSchema,
        requestSchema: GetMazdaWarrantySymptomsApiArgSchema,
      },
    }),
    getMazdaWarrantyDamages: build.query<
      GetMazdaWarrantyDamagesApiResponse,
      GetMazdaWarrantyDamagesApiArg
    >({
      query: (queryArg) => ({
        url: `/mazda_omn/v1/warranty/warranty-damages`,
        params: {assemblyGroupCode: queryArg.assemblyGroupCode},
        queryArg,
      }),
      extraOptions: {
        responseSchema: GetMazdaWarrantyDamagesApiResponseSchema,
        requestSchema: GetMazdaWarrantyDamagesApiArgSchema,
      },
    }),
    getMazdaWarrantyLocations: build.query<
      GetMazdaWarrantyLocationsApiResponse,
      GetMazdaWarrantyLocationsApiArg
    >({
      query: (queryArg) => ({
        url: `/mazda_omn/v1/warranty/warranty-locations`,
        params: {
          assemblyGroupCode: queryArg.assemblyGroupCode,
          subAssemblyGroupCode: queryArg.subAssemblyGroupCode,
        },
        queryArg,
      }),
      extraOptions: {
        responseSchema: GetMazdaWarrantyLocationsApiResponseSchema,
        requestSchema: GetMazdaWarrantyLocationsApiArgSchema,
      },
    }),
    getMazdaWarrantyCausalParts: build.query<GetMazdaWarrantyCausalPartsApiResponse, void>({
      query: () => ({
        url: `/mazda_omn/v1/warranty/causal-parts`,
      }),
      extraOptions: {
        responseSchema: GetMazdaWarrantyCausalPartsApiResponseSchema,
      },
    }),
    getMazdaWarrantySublets: build.query<GetMazdaWarrantySubletsApiResponse, void>({
      query: () => ({
        url: `/mazda_omn/v1/warranty/warranty-sublets`,
      }),
      extraOptions: {
        responseSchema: GetMazdaWarrantySubletsApiResponseSchema,
      },
    }),
  }),
});

export const {
  usePostMazdaPortalLoginQuery,
  useGetMazdaWarrantyAssemblyGroupsQuery,
  useGetMazdaWarrantySubAssemblyGroupsQuery,
  useGetMazdaWarrantySymptomsQuery,
  useGetMazdaWarrantyDamagesQuery,
  useGetMazdaWarrantyLocationsQuery,
  useGetMazdaWarrantyCausalPartsQuery,
  useGetMazdaWarrantySubletsQuery,
} = metadaMazdaIntegrationApi;
